import { PlayRequestStatusesEnum, useGetMyGameRequestQuery } from 'types/generated/client';
import { useViewer } from 'hooks/useViewer';

/**
 * The viewer's own request for a game in the given status: PENDING (default) is the
 * live ask the detail modal can cancel, ACCEPTED is the seat "Leave game" gives up.
 * Skips until both the viewer and an event id are known.
 * `cache-and-network` so it reflects a request just created in the modal above.
 */
export function useMyGameRequest(
  eventId: string | undefined | null,
  status: PlayRequestStatusesEnum = PlayRequestStatusesEnum.Pending,
) {
  const { userId } = useViewer();

  const { data, loading, refetch } = useGetMyGameRequestQuery({
    variables: { eventId: eventId ?? '', userId: userId ?? '', status },
    skip: !eventId || !userId,
    fetchPolicy: 'cache-and-network',
  });

  return { myRequest: data?.playRequests?.[0] ?? null, isLoading: loading, refetch };
}
